// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3REZ7","title":"styles_title__2bzNR","hiddenValue":"styles_hiddenValue__1BsWB","value":"styles_value__1Rybf"};